import { FC } from 'react';
import { IReferral } from 'src/types/org/ai/schoolInterface';
import { FieldRow, FieldLabel } from 'src/generic/component';
import {  Input } from 'src/generic/component/form';
import { IFieldProps } from 'src/generic/type/form';
import { ErrorManager } from 'src/types/validation';
import { Draft } from 'src/types/common';

export const Referral: FC<IFieldProps<IReferral>> = ({ item: initial, errors, readOnly, onUpdate }) => {
  const {
    name,
    email
  } = initial;

  const { getError, hasError } = ErrorManager(errors);

  const changed = (updates: Draft<IReferral>) => {
    if (onUpdate) {
      onUpdate({ ...initial, ...updates });
    }
  };

  return <>
    <FieldRow>
      <FieldLabel variant="body1">Referral Name</FieldLabel>
      <Input disabled={readOnly} validation={hasError('name') ? 'error' : undefined} validationMsg={getError('name')}
        onChange={(e) => { changed({ name: e.target.value }); }}
        value={name}
      />
    </FieldRow>
    <FieldRow>
      <FieldLabel variant="body1">Referral Email</FieldLabel>
      <Input disabled={readOnly} validation={hasError('email') ? 'error' : undefined} validationMsg={getError('email')}
        onChange={(e) => { changed({ email: e.target.value }); }}
        value={email}
      />
    </FieldRow>
  </>;
};
